function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9032 0.5H4.09677C2.38647 0.5 1 1.8674 1 3.55417V21.4458C1 23.1326 2.38647 24.5 4.09677 24.5H21.9032C23.6135 24.5 25 23.1326 25 21.4458V3.55417C25 1.8674 23.6135 0.5 21.9032 0.5Z",
  stroke: "#899296"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.1928 7.60156C16.0879 7.60352 18.6877 9.49356 20.1479 12.6582C20.2053 12.7814 20.2053 12.9209 20.1479 13.0442C18.6884 16.2094 16.0879 18.0995 13.1928 18.1014H13.1886C10.2934 18.0995 7.69362 16.2094 6.23344 13.0442C6.17674 12.9209 6.17674 12.7814 6.23344 12.6582C7.69362 9.49356 10.2941 7.60352 13.1886 7.60156H13.1928ZM13.1907 8.57951C10.7855 8.58016 8.59171 10.1729 7.28973 12.8512C8.59171 15.5301 10.7848 17.1228 13.1907 17.1235C15.5965 17.1228 17.7896 15.5301 19.0916 12.8512C17.7896 10.1729 15.5965 8.58016 13.1907 8.57951ZM13.1904 10.3012C14.7003 10.3012 15.9288 11.4454 15.9288 12.8517C15.9288 14.2573 14.7003 15.4009 13.1904 15.4009C11.6806 15.4009 10.4528 14.2573 10.4528 12.8517C10.4528 11.4454 11.6806 10.3012 13.1904 10.3012ZM13.1904 11.2792C12.2595 11.2792 11.5028 11.9846 11.5028 12.8517C11.5028 13.7182 12.2595 14.4229 13.1904 14.4229C14.1214 14.4229 14.8788 13.7182 14.8788 12.8517C14.8788 11.9846 14.1214 11.2792 13.1904 11.2792Z",
  fill: "#899296"
});

var SvgIconButtonEyeBorder = function SvgIconButtonEyeBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconButtonEyeBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_button_eye_border.e7f3ada2.svg";
export { ForwardRef as ReactComponent };